import React, {useState} from 'react'
import {Inertia} from '@inertiajs/inertia'
import AppLayout from '@/Layouts/AppLayout'
import OrganizationLayout from '@/Layouts/OrganizationLayout'
import {LabeledInput} from '@/Components/Form'
import {MapPin} from "react-feather";
import {LabeledPlacesAutocomplete} from "@/Components/PlacesAutocomplete";
import {Container, FormError} from "@/Components";
import {OnboardingSteps} from "@/Pages/Organization/Onboarding/Partials/Steps";
import {InertiaLink} from "@inertiajs/inertia-react";
import {DateInput} from "@/Components/Team/DateInput";

export default function OnboardingReporting({
   errors,
   team,
 }) {

  const errorKey = `updateTeam.${team?.data?.id}`;

  let [dirty, setDirty] = useState(false)
  let [disableForm, setDisableForm] = useState(false)
  let [values, setValues] = useState({
    name: "",
    report_frequency: 1,
    start_date: new Date(),
    location: "",
    location_place_id: null
  });

  function handleSave(e) {
    e.preventDefault()

    if (disableForm) return false;
    if (!dirty) return false;

    let data = {
      name: values.name,
      report_frequency: values.report_frequency,
      location: values.location,
      location_place_id: values.location_place_id,
      start_date: values.start_date
    };

    setDisableForm(true);

    Inertia.put(`/teams/${team?.data?.id}`, data, {
        onSuccess: () => {
          setDirty(false);
          Inertia.visit('/onboarding/activities');
        },
        onFinish: () => (setDisableForm(false))
      });
  }

  function setLocation({ description, place_id }) {
    setValues(prevValues => ({
      ...prevValues,
      location: description,
      location_place_id: place_id
    }));
  }

  function setDate(date, property) {
    setValues(prevValues => ({
      ...prevValues,
      [property]: date
    }));
  }

  function handleUpdate(event) {
    setValues( prevValues => {
      return { ...prevValues,[event.target.name]: event.target.value}
    })
    setDirty(true)
  }

  function SettingsSaveButton() {
    let disabled = false

    if (!dirty) {
      disabled = true
    }

    return <button
      disabled={disabled}
      onClick={handleSave}
      className="self-end ml-3 btn"
    >
      Save changes
    </button>
  }

  return <>

      <OnboardingSteps currentStep={0} steps={['Reporting', 'Activities', 'Reporters']}/>

      <h4 className="text-xl mb-4 font-bold">Set up your reporting preferences</h4>

      <Container padding="" className="md:dots-orange md:dots-orange--no-top-overflow relative z-10">
        <form className="w-full flex flex-row flex-wrap bg-white p-8" >

          <div className="w-full mb-8">
            <LabeledInput
              title="Team name*"
              name="name"
              type="text"
              required="required"
              placeholder="Enter team name"
              value={values.name}
              onChange={handleUpdate}
              error={errors && errors[errorKey]?.name}
            />
          </div>

          <div className="w-full mb-8 relative">
            <LabeledPlacesAutocomplete
              title="Add geographic location*"
              placeholder="Enter name of town or region"
              className="pl-10 w-full"
              name="location"
              required="required"
              defaultValue={values.location}
              onChange={setLocation}
            />
            <MapPin size={18} className="absolute left-3 -mt-8" />

            <FormError error={errors && errors[errorKey]?.location} />
            <FormError error={errors && errors[errorKey]?.location_place_id} />
          </div>

          <div className="w-full md:w-1/2 mb-8 md:pr-8">
            <label>
              <span className="block mb-1">Start date</span>
            </label>
            <DateInput
              setDate={date => setDate(date, 'start_date')}
              selectedDate={values.start_date}
              disableDay={true}
              allowPast={true}
            />
            <p className="mt-1 text-sm text-gray-600">Change the start date if you want the team to start in the past or in the future</p>
            <FormError error={errors && errors[errorKey]?.start_date} />
          </div>
          <div className="w-full md:w-1/2 mb-8 md:pl-8">
            <p>How often should data be reported</p>
            <div className="flex">
              <label className="mr-4">
                <input
                  checked={values.report_frequency == 1}
                  value={1}
                  type="radio"
                  name="report_frequency"
                  onChange={handleUpdate}
                />
                <span className="ml-2">Monthly</span>
              </label>

              <label className="mr-4">
                <input
                  checked={values.report_frequency == 3}
                  value={3}
                  type="radio"
                  name="report_frequency"
                  onChange={handleUpdate}
                />
                <span className="ml-2">Quarterly</span>
              </label>
              <label className="mr-4">
                <input
                  checked={values.report_frequency == 12}
                  value={12}
                  type="radio"
                  name="report_frequency"
                  onChange={handleUpdate}
                />
                <span className="ml-2">Yearly</span>
              </label>
            </div>
            <FormError error={errors && errors[errorKey]?.report_frequency} />
          </div>

          <div className="flex justify-end w-full">
            <SettingsSaveButton/>
          </div>
        </form>
      </Container>
    </>
}

OnboardingReporting.layout = page => (
  <AppLayout title="Onboarding - Reporting">
    <OrganizationLayout header="">
      {page}
    </OrganizationLayout>
  </AppLayout>
)
